export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              关于我们
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              了解黑料在线 —— 专注暴走黑料与黑料社系列内容的聚合平台
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
            <div className="space-y-5">
              <div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">平台定位</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  黑料在线⚡是一个专注于整理和聚合暴走黑料、黑料社等特色黑料系列内容的娱乐资讯平台。
                  我们致力于为广大吃瓜群众提供系统化、系列化的黑料内容在线观看服务，
                  涵盖暴走黑料在线观看、黑料社在线观看等热门合辑。平台由资深娱乐编辑团队运营，
                  每日追踪娱乐圈、网红圈、综艺圈的最新动态，以最快的速度呈现最全的黑料系列合集。
                </p>
              </div>

              <div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">内容理念</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  我们坚持"系列化整理、多维度呈现"的内容理念。暴走黑料系列侧重快速、全面的热点追踪，
                  黑料社精选则专注于深度分析和独家视角。所有内容均来自公开网络信息整理，
                  我们不对原始信息的真实性做担保，但会尽力通过多源交叉比对提高内容可信度。
                  平台倡导理性吃瓜、文明讨论的社区氛围。
                </p>
              </div>

              <div>
                <h3 className="text-base font-semibold text-foreground-800 mb-2">运营数据</h3>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-3">
                  <div className="text-center p-3 rounded-xl bg-background-50 border border-background-200/40">
                    <div className="text-xl font-bold text-primary-500 font-heading">2000+</div>
                    <div className="text-xs text-foreground-400 mt-1">内容条目</div>
                  </div>
                  <div className="text-center p-3 rounded-xl bg-background-50 border border-background-200/40">
                    <div className="text-xl font-bold text-accent-500 font-heading">12+</div>
                    <div className="text-xs text-foreground-400 mt-1">品牌系列</div>
                  </div>
                  <div className="text-center p-3 rounded-xl bg-background-50 border border-background-200/40">
                    <div className="text-xl font-bold text-primary-500 font-heading">每日更新</div>
                    <div className="text-xs text-foreground-400 mt-1">更新频率</div>
                  </div>
                  <div className="text-center p-3 rounded-xl bg-background-50 border border-background-200/40">
                    <div className="text-xl font-bold text-accent-500 font-heading">50万+</div>
                    <div className="text-xs text-foreground-400 mt-1">月活用户</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}